(function () {
  const AVAILABLE_PARAM = 'available';
  const TRUE_VALUE = 'true';
  const PROMO_PATH = '/collections/promocoes';

  function currentUrl() {
    return new URL(window.location.href);
  }

  function cleanNavigationParams(url) {
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    return url;
  }

  function normalizePath(path) {
    return (path || '').replace(/\/+$/, '') || '/';
  }

  function isAvailableActive() {
    return currentUrl().searchParams.get(AVAILABLE_PARAM) === TRUE_VALUE;
  }

  function isPromoActive(button) {
    const promoPath = normalizePath(button?.dataset.promoUrl || PROMO_PATH);
    return normalizePath(window.location.pathname) === promoPath;
  }

  function buildAvailableUrl() {
    const url = cleanNavigationParams(currentUrl());

    if (url.searchParams.get(AVAILABLE_PARAM) === TRUE_VALUE) {
      url.searchParams.delete(AVAILABLE_PARAM);
    } else {
      url.searchParams.set(AVAILABLE_PARAM, TRUE_VALUE);
    }

    return url;
  }

  function buildPromoUrl(button) {
    const targetPath = isPromoActive(button) ? button.dataset.allUrl : button.dataset.promoUrl;
    const nextUrl = new URL(targetPath || PROMO_PATH, window.location.origin);
    const sourceUrl = currentUrl();

    sourceUrl.searchParams.forEach((value, key) => {
      if (key === 'page' || key === 'section_id') return;
      nextUrl.searchParams.append(key, value);
    });

    return cleanNavigationParams(nextUrl);
  }

  function getFacetsFormComponent() {
    return document.querySelector('facets-form-component[section-id], facets-form-component');
  }

  function updateCollectionByUrl(url) {
    const facetsForm = getFacetsFormComponent();

    setAvailableInputs(url.searchParams.get(AVAILABLE_PARAM) === TRUE_VALUE);

    if (facetsForm && typeof facetsForm.updateFiltersByURL === 'function') {
      facetsForm.updateFiltersByURL(url.toString());
      return;
    }

    window.history.pushState({}, '', url.toString());
    refreshCustomFilters();
  }

  function productIsUnavailable(card) {
    const availableSource = card.matches('[data-product-available]')
      ? card
      : card.querySelector('[data-product-available]');

    if (availableSource) {
      return availableSource.dataset.productAvailable === 'false';
    }

    const badge = card.querySelector('.product-badges__badge');
    const badgeText = badge ? badge.textContent.trim().toLowerCase() : '';

    return badgeText.includes('esgotado') || badgeText.includes('sold out') || badgeText.includes('unavailable');
  }

  function clearHiddenProducts() {
    document.querySelectorAll('.product-grid__item').forEach((card) => {
      if (!(card instanceof HTMLElement)) return;

      card.hidden = false;
      card.removeAttribute('hidden');
      card.classList.remove('hidden');
      card.style.display = '';
    });
  }

  function applyAvailableFilter() {
    if (!isAvailableActive()) {
      clearHiddenProducts();
      return;
    }

    document.querySelectorAll('.product-grid__item').forEach((card) => {
      if (!(card instanceof HTMLElement)) return;

      const shouldHide = productIsUnavailable(card);
      card.hidden = shouldHide;
      card.style.display = shouldHide ? 'none' : '';
    });
  }

  function setAvailableInputs(active) {
    document.querySelectorAll('facets-form-component form, .facets__form').forEach((form) => {
      if (!(form instanceof HTMLFormElement)) return;

      let input = form.querySelector('input[name="available"][data-custom-available-input]');

      if (!active) {
        input?.remove();
        return;
      }

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = AVAILABLE_PARAM;
        input.dataset.customAvailableInput = 'true';
        form.appendChild(input);
      }

      input.value = TRUE_VALUE;
    });
  }

  function updateButtons() {
    const availableActive = isAvailableActive();

    document.querySelectorAll('[data-available-toggle]').forEach((button) => {
      if (!(button instanceof HTMLAnchorElement)) return;

      button.href = buildAvailableUrl().toString();
      button.classList.toggle('active', availableActive);
      button.setAttribute('aria-pressed', availableActive ? 'true' : 'false');
    });

    document.querySelectorAll('[data-promo-toggle]').forEach((button) => {
      if (!(button instanceof HTMLAnchorElement)) return;

      const promoActive = isPromoActive(button);
      button.dataset.active = promoActive ? 'true' : 'false';
      button.href = buildPromoUrl(button).toString();
      button.classList.toggle('active', promoActive);
      button.setAttribute('aria-pressed', promoActive ? 'true' : 'false');
    });
  }

  function updateFacetRemoveUrls() {
    const availableActive = isAvailableActive();

    document.querySelectorAll('facet-remove-component[data-url]').forEach((component) => {
      if (!(component instanceof HTMLElement)) return;

      const url = new URL(component.dataset.url || window.location.href, window.location.origin);
      const clearsEverything = Boolean(component.querySelector('.facets__clear-all'));

      url.searchParams.delete(AVAILABLE_PARAM);

      if (availableActive && !clearsEverything) {
        url.searchParams.set(AVAILABLE_PARAM, TRUE_VALUE);
      }

      component.dataset.url = cleanNavigationParams(url).toString();
    });
  }

  function refreshCustomFilters() {
    setAvailableInputs(isAvailableActive());
    updateButtons();
    updateFacetRemoveUrls();
    applyAvailableFilter();
  }

  function bindAvailableButtons() {
    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-available-toggle]') : null;
      if (!(button instanceof HTMLAnchorElement)) return;

      event.preventDefault();

      const nextUrl = buildAvailableUrl();
      clearHiddenProducts();
      updateCollectionByUrl(nextUrl);
    });

    window.addEventListener('popstate', refreshCustomFilters);
  }

  function bindPromoButtons() {
    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-promo-toggle]') : null;
      if (!(button instanceof HTMLAnchorElement)) return;

      event.preventDefault();
      window.location.href = buildPromoUrl(button).toString();
    });
  }

  function observeCollectionChanges() {
    const observer = new MutationObserver(refreshCustomFilters);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    if (!document.querySelector('[data-available-toggle], [data-promo-toggle], .main-collection-grid')) return;

    bindAvailableButtons();
    bindPromoButtons();
    refreshCustomFilters();
    observeCollectionChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
